import React from 'react';

const SampleLink: React.FC<{ href: string; label?: string }> = ({ href, label = 'скачать образец' }) => (
  <a href={href} download className="text-emerald-700 underline underline-offset-2 font-medium hover:text-emerald-800">
    {label}
  </a>
);

const List: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <ol className="list-decimal list-outside ml-4 space-y-1 mt-1">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ol>
);

/** Требования к прайсу (Excel). */
export const PriceReqs: React.FC = () => (
  <>
    <p className="font-semibold text-gray-900">Требования к прайсу</p>
    <List items={[
      <>Файл <b>.xls / .xlsx</b> на одном листе</>,
      'Без картинок',
      <>Обязательные столбцы: «Наименование», «ед. изм.», «цена» — остальные лучше удалить</>,
      <>Нет строк выше и левее столбца «Наименование»</>,
    ]} />
    <p className="mt-2"><SampleLink href="/samples/obrazec_price.xlsx" /></p>
  </>
);

/** Требования к заявке. Теперь их почти нет — принимаем что есть. */
export const ZayavkaReqs: React.FC = () => (
  <>
    <p className="font-semibold text-gray-900">Заявку принимаем в любом виде</p>
    <p className="mt-1">
      Excel, CSV, PDF, Word или фотографию — переделывать файл под форму не нужно.
      Структуру разберём сами.
    </p>
    <List items={[
      <><b>Таблица</b> (.xlsx, .xls, .csv) — шапка может быть где угодно, листов может быть несколько</>,
      <><b>PDF</b> — и с текстовым слоем, и скан</>,
      <><b>Word</b> (.docx) — таблицей или списком</>,
      <><b>Фото или скриншот</b> (jpg, png, heic) — снимайте так, чтобы таблица была видна целиком и текст читался</>,
      <>Многостраничную заявку можно прислать <b>несколькими файлами сразу</b></>,
    ]} />
    <p className="mt-2 text-gray-600">
      Что мы поняли из файла, вы увидите и сможете поправить до расчёта.
    </p>
    <p className="mt-2"><SampleLink href="/samples/obrazec_zayavka.xlsx" label="скачать образец таблицы" /></p>
  </>
);

/** Требования к рабочей документации (проекту, PDF). */
export const ProjectReqs: React.FC = () => (
  <>
    <p className="font-semibold text-gray-900">Требования к проекту (PDF)</p>
    <List items={[
      <>Файл <b>.pdf</b> с рабочими чертежами и спецификациями материалов</>,
      'Сканы тоже подходят — страницы распознаёт нейросеть',
      <>Разделы АР и КЖ, скорее всего, не распознаются — ИИ пока недостаточно обучен на «пирогах»</>,
    ]} />
  </>
);
